"use client";
import { useStepperContext } from "@/context/stepper-provider";
import OfflineDefine from "@/components/define/offline-define";
import OfflinePalletConfig from "@/components/pallet-config/offline-pallet-config";
import OfflineLpnNo from "@/components/LPN-No/offline-lpn-no";
import OfflinePreShip from "@/components/pre-ship/offline-pre-ship";
import OfflineShipTestTruckLayout from "@/components/post-ship/offline-ship-test-truck-layout";
import OfflinePostShip from "@/components/post-ship/offline-post-ship";
import OfflineStackTestLayout from "@/components/post-stack/offline-stack-test-layout";
import OfflinePostStack from "@/components/post-stack/offline-post-stack";
import OfflineSummary from "@/components/summary/offline-summary";
import OfflineSynopsis from "@/components/synopsis/offline-synopsis";
import OfflineImages from "@/components/imagesTab/offline-images";
import { useLocation, useParams } from "react-router-dom";
import Navbar from "@/components/top-nav";
import Stepper from "@/components/stepper";

export default function OfflineEditProject() {
  const { stepper } = useStepperContext();
  const { id: projectId } = useParams<{ id: string }>();
  const location = useLocation();
  // const isOffline = location.pathname.includes('/offline');
  return (
    <div className="">
         <Navbar />
         <Stepper />
      {stepper.when("1", () => (
        <OfflineDefine projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("2", () => (
        <OfflinePalletConfig projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("3", () => (
        <OfflineLpnNo projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("4", () => (
        <OfflinePreShip projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("5", () => (
        <OfflineShipTestTruckLayout projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("6", () => (
        <OfflinePostShip projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("7", () => (
        <OfflineStackTestLayout projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("8", () => (
        <OfflinePostStack projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("9", () => (
        <OfflineSummary projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("10", () => (
        <OfflineSynopsis projectId={projectId} isOffline={true} />
      ))}
      {stepper.when("11", () => (
        <OfflineImages projectId={projectId} isOffline={true} />
      ))}
    </div>
  );
} 